import { FC } from 'react';
import { compose } from 'redux';
import { injectAnalyticsScope } from 'ia-react-core';
import DocumentListItem, { DocumentListItemProps } from './DocumentListItem';

export default compose<FC<DocumentListItemProps>>(
  injectAnalyticsScope({
    key: 'DocumentListItem',
    values: ({ document }: DocumentListItemProps) => (
      {
        year: document.year,
        systemCode: document.contract.systemCode,
      }
    ),
  }),
)(DocumentListItem);
